
export enum SquareState {
    Empty,
    Arrow,

    White1,
    White2,
    White3,
    White4,

    Black1,
    Black2,
    Black3,
    Black4
}
